import React, { Component } from 'react'

export default class Slider extends Component {
    state = {
        value: this.props.value,
        disabled: this.props.disabled
    }

    static getDerivedStateFromProps(props, state) {
        return {
            disabled: props.disabled,
            value: props.value
        };
    }

    render() {
        return (
            <div
                style={{
                    float: "right",
                    height: "100%",
                    width: "50%"
                }}
            >
                <input
                    style={{
                        marginLeft: "5%",
                        height: "100%",
                        width: "25%"
                    }}
                    disabled={this.state.disabled}  
                    type="number" 
                    value={this.props.value}
                    readOnly
                />
                <input
                    className="slider" 
                    style={{
                        margin: "auto",
                        height: "100%",
                        width: "70%"
                    }}
                    type="range"
                    min={1}
                    max={this.props.max}
                    value={this.props.value}
                    onChange={(e)=>{
                        if (this.props.handleChange !== undefined)
                            this.props.handleChange(parseInt(e.target.value))
                    }}
                />
            </div>
        );
    }
}
